import { Error404 } from "../../components/errors";

export default function Errors404(){

    return(
        <>
        <Error404/>
        </>
    )

}